import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { CryptPasswordService } from 'app/shared/services/crypt-password/crypt-password.service';
import { DataService } from 'app/shared/services/data/data.service';
import { TitleService } from 'app/shared/services/title/title.service';
import { UiService } from 'app/shared/services/ui/ui.service';
import { UserService } from 'app/shared/services/user/user.service';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit {
  updatePasswordProfilForm: FormGroup;
  paswordUpdate = false;
  loading = false;
  inactive = false;

  showError = false;

  constructor(
    private dataService: DataService,
    private formBuilder: FormBuilder,
    private cryptPasswordService: CryptPasswordService,
    private userService: UserService,
    private uiService: UiService,
    private titleService: TitleService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  onSubmit(): void {
    if (this.updatePasswordProfilForm.invalid) {
      this.errorsToManage();
      return;
    }

    this.loading = true;

    const oldPass = this.cryptPasswordService.cryptPassword(this.updatePasswordProfilForm.get('oldPassword').value);
    const newPass = this.cryptPasswordService.cryptPassword(this.updatePasswordProfilForm.get('newPassword').value);
    const confirmPassword = this.cryptPasswordService.cryptPassword(this.updatePasswordProfilForm.get('confirmNewPassword').value);

    const passwordToUpdate = {
      oldPassword: oldPass,
      newPassword: newPass
    };

    const check = (newPass === confirmPassword);

    check ? this.ifCheckPasswordIsOk(passwordToUpdate) : this.ifCheckPasswordIsNotOk();

  }

  getShowValue(): void {
    this.dataService.showMenuProfil.next(true);
    this.titleService.title.next('Mon profil')
  }

  isInactive(inputValue: string): void {
    inputValue ? this.inactive = true : this.inactive = false;
  }

  private errorsToManage(): void {
    const old = this.f.oldPassword.errors?.required;
    const newPass = this.f.newPassword.errors?.required;
    const confirm = this.f.confirmNewPassword.errors?.required;
    const check = (old && newPass && confirm);

    if (check) {
      this.uiService.openSnackBar(`les champs sont vides`, '');
    } else {
      if (old) {
        this.uiService.openSnackBar(`Champ ancien mot de passe requis`, '');
      }
      if (newPass) {
        this.uiService.openSnackBar(`Champ nouveau mot de passe requis`, '');
      }
      if (confirm) {
        this.uiService.openSnackBar(`Confirmez votre mot de passe`, '');
      }
      if (!this.f.newPassword.valid) {
        this.uiService.openSnackBar(`Minimum de huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial`, '');
        // this.uiService.openSnackBar(`Mot de passe incorrect : Minimum huit caractères, au moins une lettre et un chiffre`, '');
      }
      if (!this.f.confirmNewPassword.valid) {
        this.uiService.openSnackBar(`Minimum de huit caractères, au moins une lettre majuscule, une lettre minuscule, un chiffre et un caractère spécial`, '');
        // this.uiService.openSnackBar(`Mot de passe incorrect : Minimum huit caractères, au moins une lettre et un chiffre`, '');
      }
    }
  }

  get f() {
    return this.updatePasswordProfilForm.controls;
  }

  private ifCheckPasswordIsOk(pUpDate): void {
    this.userService.updatePasswordUser(pUpDate).subscribe(() => { this.paswordUpdate = true; });
    setTimeout(() => { this.paswordUpdate = false; this.dataService.showMenuProfil.next(true); }, 3500);

  }
  private ifCheckPasswordIsNotOk(): void {
    this.uiService.openSnackBar(`La confirmation du mot de passe n'est pas valide`, '');
    this.inactive = false;
    this.loading = false;
    this.updatePasswordProfilForm.reset({
      oldPassword: this.f.oldPassword.value,
      newPassword: this.f.newPassword.value,
      confirmNewPassword: ''
    });
  }
  private initForm(): void {
    this.updatePasswordProfilForm = this.formBuilder.group({
      oldPassword: ['', [Validators.required]],
      newPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]],
      confirmNewPassword: ['', [Validators.required, Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/)]]
    });
  }

}

// /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/

// /^(?=.*[A-z])(?=.*[0-9])(?=.*[$@_-*])(?!.*[iIoO])\S{6,12}$/
